import { render, staticRenderFns } from "./PrivateAdvertiser.vue?vue&type=template&id=6813a0ea&scoped=true"
import script from "./PrivateAdvertiser.vue?vue&type=script&lang=js"
export * from "./PrivateAdvertiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6813a0ea",
  null
  
)

export default component.exports